module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#fm-1"
    }
  }, [_vm._v("Introduction, by Thomas Sugrue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Preface#fm-2"
    }
  }, [_vm._v("Preface, by Walter Kaufmann")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#ch-1"
    }
  }, [_vm._v("  1. The Golden Mouth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  2. Thy Brother’s Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  3. Wanderers Upon the Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  4. The Badge of Shame")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  5. The Murderous Lie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  6. “Money Was Their God”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  7. Godfathers of Belsen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  8. Workers of Iniquity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  9. The “Inevitable Failure”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Pride, Arrogance, and Hate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Epilogue#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Appendix#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Appendix#sec-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. “The Jews” in St. John’s Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Appendix#sec-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. The Ritual-Murder Charge in Modern Times")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Appendix#sec-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Letter to Edouard Drumont")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Appendix#sec-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Jewish Children and the Nazis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Bibliography#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Endnotes#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_vm._v("Index")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e33ab34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Contents.vue
// module id = 75
// module chunks = 0